export const videoFirstComparator = (
  a: { videoUrl: string | null },
  b: { videoUrl: string | null },
) => {
  if (!a.videoUrl) return 1;
  if (!b.videoUrl) return -1;
  if (a.videoUrl === b.videoUrl) return 0;
  return 1;
};
